import { asyncToGenerator as _asyncToGenerator, createForOfIteratorHelperLoose as _createForOfIteratorHelperLoose } from '../_virtual/_rollupPluginBabelHelpers.js';
import _regeneratorRuntime from '../node_modules/regenerator-runtime/runtime.esm.js';

function handleSettled(_x) {
  return _handleSettled.apply(this, arguments);
}

function _handleSettled() {
  _handleSettled = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(promises) {
    var values, results, _iterator, _step, result;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            values = [];
            _context.next = 3;
            return Promise.allSettled(promises);

          case 3:
            results = _context.sent;

            for (_iterator = _createForOfIteratorHelperLoose(results); !(_step = _iterator()).done;) {
              result = _step.value;
              if (result.status === 'fulfilled') values.push(result.value);else if (result.status === 'rejected') values.push(null);
            }

            return _context.abrupt("return", values);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _handleSettled.apply(this, arguments);
}

export { handleSettled };
//# sourceMappingURL=handleSettled.esm.js.map
